<article
  class="
    lum-c-reporting-stock-snapshot lum-page lum-page--full-height lum-page__card
  "
>
  <header class="lum-page-header">
    <div class="lum-page-header__heading-group d-flex align-items-center justify-content-between w-100">
      <h2 class="lum-page-header__heading mr-16">Stock Snapshot</h2>
      <div class="lum-c-reporting-stock-snapshot__filters">
        <div class="lum-c-reporting-stock-snapshot__filter">
          <div class="lum-label lum-c-reporting-stock-snapshot__filter-label">
            {{ ('red_DV-3389_inventory_reconciliation_report' | featureFlag) ? 'From' : 'As Of' }}
          </div>
          <input
            type="text"
            class="lum-input lum-c-reporting-stock-snapshot__filter-control"
            placeholder="Filter By Date"
            size="12"
            matInput
            [(ngModel)]="selectedDate"
            [matDatepicker]="orderDatepicker"
            (dateChange)="onDateChange($event, 'start')"
          />
          <mat-datepicker-toggle
            class="lum-c-reporting-stock-snapshot__filter-affix"
            [for]="orderDatepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #orderDatepicker></mat-datepicker>
        </div>
        <div class="lum-c-reporting-stock-snapshot__filter">
          <input
            type="time"
            class="lum-input lum-c-reporting-stock-snapshot__filter-control"
            size="12"
            matInput
            [(ngModel)]="selectedTime"
            (input)="onTimeChange($event, 'start')"
          />
        </div>
        <ng-container *ngIf="('red_DV-3389_inventory_reconciliation_report' | featureFlag)">
          <div class="lum-c-reporting-stock-snapshot__filter">
            <div class="lum-label lum-c-reporting-stock-snapshot__filter-label">
              To
            </div>
            <input
              type="text"
              class="lum-input lum-c-reporting-stock-snapshot__filter-control"
              placeholder="Filter By Date"
              size="12"
              matInput
              [(ngModel)]="selectedDateEnd"
              [matDatepicker]="orderDateEndPicker"
              (dateChange)="onDateChange($event, 'end')"
            />
            <mat-datepicker-toggle
              class="lum-c-reporting-stock-snapshot__filter-affix"
              [for]="orderDateEndPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #orderDateEndPicker></mat-datepicker>
          </div>
          <div class="lum-c-reporting-stock-snapshot__filter">
            <input
              type="time"
              class="lum-input lum-c-reporting-stock-snapshot__filter-control"
              size="12"
              matInput
              [(ngModel)]="selectedTimeEnd"
              (input)="onTimeChange($event, 'end')"
            />
          </div>
        </ng-container>
        <div class="lum-c-reporting-stock-snapshot__filter">
          <mat-checkbox [(ngModel)]="includeAllZeroStock">
            Include All Zero Stock Entries
          </mat-checkbox>
        </div>
        <div class="lum-c-reporting-stock-snapshot__action">
          <button
            type="button"
            class="lum-button lum-button--large"
            mat-button
            [disabled]="!selectedDate || isExporting"
            (click)="exportToExcel()"
          >
            <lum-ui-icon
              color="#ffffff"
              width="12"
              height="12"
              class="mr-2"
              icon="download-button"
            ></lum-ui-icon>
            Export to Excel
          </button>
          <mat-spinner
            *ngIf="isExporting"
            [diameter]="20"
            class="ml-2"
          ></mat-spinner>
        </div>
      </div>
    </div>
  </header>

  <div class="lum-page-content lum-page__ag-grid">
    <lum-report-stock-snapshot-ag-table
      class="lum-page__ag-grid__table"
      [selectedDate]="selectedDate"
      [selectedDateEnd]="selectedDateEnd"
      [includeAllData]="includeAllZeroStock"
    ></lum-report-stock-snapshot-ag-table>
  </div>
</article>
